import React, {useEffect, useState, useContext} from 'react'
import { Link, NavLink } from 'react-router-dom'
import AuthContext from '../context/AuthContext'


import SocietySideInner from './SocietySideInner'

const SocietySidebar = () => {

    let {user} = useContext(AuthContext)

    return (
    


<SocietySideInner/>


)
}

export default SocietySidebar